angular.module('jv.Requisition.Analytics.Controller', ['JV.Core.Directives'])
    .controller('jv.Requisition.Analytics.Controller', ['$scope', 'Reqs', 'i18n', function ($scope, Reqs, i18n) {
        $scope.flags.loading = true;
        $scope.showTTFWidget = false;
        $scope.industryMedian = 0;
        $scope.companyMedian = 0;
        $scope.daysOpen = 0;
        $scope.timeToFill = 0;
        $scope.displayTimeToFill = i18n.CAMPAIGN_CAMPAIGNCONTACTGRID_N_A;
        $scope.industryCategory = '';
        $scope.display = true;

        $scope.$watch('industryCategory', function (newValue) {
            //TODO: Change to !$scope.display
            if (newValue && $.trim(newValue.text) !== '' && $scope.params && $scope.params.id && $scope.display === false) {
                $scope.showTTFWidget = false;
                $scope.flags.loading = true;
                Reqs.updatedJobHiringPrediction($scope.params.id, newValue.text, function (response) {
                    //TODO: Extract out common chart configs
                    if (response && response.jobHiringPrediction && $.trim(response.jobHiringPrediction.expectedTimeToFill) !== '') {
                        $scope.timeToFill = response.jobHiringPrediction.expectedTimeToFill;
                        $scope.displayTimeToFill = response.jobHiringPrediction.expectedTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.jobOpenedDays) {
                        $scope.daysOpen = response.jobHiringPrediction.jobOpenedDays;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.companyCategoryTimeToFill) {
                        $scope.companyMedian = response.jobHiringPrediction.companyCategoryTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.industryCategoryTimeToFill) {
                        $scope.industryMedian = response.jobHiringPrediction.industryCategoryTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.prediction) {
                        $scope.detailsPrediction = response.jobHiringPrediction.notes.prediction;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.industry) {
                        $scope.detailsIndustry = response.jobHiringPrediction.notes.industry;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.company) {
                        $scope.detailsCompany = response.jobHiringPrediction.notes.company;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.cbsaname) {
                        $scope.location = response.jobHiringPrediction.cbsaname;
                    }

                    $scope.display = true;
                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.standardJobCategory) {
                        $scope.industryCategoryDisplay = response.jobHiringPrediction.standardJobCategory;
                        angular.forEach(response.standardJobCategoryNames, function (val, key) {
                            if ($scope.industryCategoryDisplay === val) {
                                $scope.industryCategory = $scope.standardJobCategoryNames[key];
                            }
                        });

                    }

                    Highcharts.seriesTypes.bar.prototype.pointAttrToOptions.dashstyle = 'dashStyle';

                    $scope.chartConfig = {
                        credits: {
                            enabled: false
                        },
                        options: {

                            chart: {
                                type: 'bar',
                                spacingRight: 35
                            },

                            plotOptions: {

                                series: {
                                    stacking: 'normal',
                                    groupPadding: 0.1,
                                    pointPadding: 0.2
                                }

                            },

                            tooltip: {
                                headerFormat: ''
                            }
                        },



                        title: {
                            text: '&nbsp',
                            useHTML: true,
                            margin: 5
                        },
                        xAxis: {
                            labels: {
                                enabled: false
                            }
                        },
                        yAxis: {
                            title: {
                                text: null
                            },
                            stackLabels: {
                                enabled: true,
                                formatter: function () {
                                    return this.total + ' days';
                                }
                            }
                        },

                        series: [

                            {
                                name: i18n.REQS_EXPECTED_TIME_TO_FILL,

                                borderColor: 'black',
                                dashStyle: 'dash',

                                data: [$scope.timeToFill],
                                color: '#79BFFC',
                                stack: 'Predict',


                                dataLabels: {
                                    enabled: true,
                                    inside: true,
                                    align: 'right',
                                    color: ($scope.timeToFill === 0) ? '#4A4A4A' : 'white'
                                }

                            },

                            {
                                name: i18n.REQS_DAYS_OPEN,
                                data: [$scope.daysOpen],
                                color: '#4A4A4A',

                                stack: 'Predict',
                                dataLabels: {
                                    enabled: true,
                                    inside: true,
                                    align: 'right',
                                    color: 'white'
                                }
                            },

                            {
                                name: i18n.REQS_COMPANY_MEDIAN,
                                data: [$scope.companyMedian],
                                stack: 'Company Median',
                                color: '#778A9A',
                                dataLabels: {
                                    inside: false
                                }
                            },

                            {
                                name: i18n.REQS_BENCHMARK_MEDIAN,
                                data: [$scope.industryMedian],
                                color: '#BABEC8',
                                stack: 'Industry Median',
                                dataLabels: {
                                    inside: false
                                }
                            }

                        ]
                    };


                    $scope.showTTFWidget = true;
                    $scope.flags.loading = false;
                    $scope.display = true;
                });
            }
        }, true);

        //Fetch data for analytics.
        var getAnalyticsData = function () {

            if ($scope.params && $scope.params.id) {
                Reqs.getEstimatedTimeToFill($scope.params.id, function (response) {
                    if (response && response.jobHiringPrediction && $.trim(response.jobHiringPrediction.expectedTimeToFill) !== '') {
                        $scope.timeToFill = response.jobHiringPrediction.expectedTimeToFill;
                        $scope.displayTimeToFill = response.jobHiringPrediction.expectedTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.jobOpenedDays) {
                        $scope.daysOpen = response.jobHiringPrediction.jobOpenedDays;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.companyCategoryTimeToFill) {
                        $scope.companyMedian = response.jobHiringPrediction.companyCategoryTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.industryCategoryTimeToFill) {
                        $scope.industryMedian = response.jobHiringPrediction.industryCategoryTimeToFill;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.prediction) {
                        $scope.detailsPrediction = response.jobHiringPrediction.notes.prediction;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.industry) {
                        $scope.detailsIndustry = response.jobHiringPrediction.notes.industry;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.notes && response.jobHiringPrediction.notes.company) {
                        $scope.detailsCompany = response.jobHiringPrediction.notes.company;
                    }

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.cbsaname) {
                        $scope.location = response.jobHiringPrediction.cbsaname;
                    }

                    $scope.standardJobCategoryNames = [];

                    if (response && response.jobHiringPrediction && response.jobHiringPrediction.standardJobCategory) {
                        $scope.industryCategoryDisplay = response.jobHiringPrediction.standardJobCategory;
                    }
                    if (response && response.standardJobCategoryNames) {
                        angular.forEach(response.standardJobCategoryNames, function (val, key) {
                            $scope.standardJobCategoryNames[key] = {
                                id: val,
                                text: val
                            };
                            if ($scope.industryCategoryDisplay && $scope.industryCategoryDisplay === val) {
                                $scope.industryCategory = $scope.standardJobCategoryNames[key];
                            }
                        });
                    }

                    Highcharts.seriesTypes.bar.prototype.pointAttrToOptions.dashstyle = 'dashStyle';

                    $scope.chartConfig = {
                        credits: {
                            enabled: false
                        },
                        options: {

                            chart: {
                                type: 'bar',
                                spacingRight: 35
                            },

                            plotOptions: {

                                series: {
                                    stacking: 'normal',
                                    groupPadding: 0.1,
                                    pointPadding: 0.2
                                }

                            },

                            tooltip: {
                                headerFormat: ''
                            }
                        },



                        title: {
                            text: '&nbsp',
                            useHTML: true,
                            margin: 5
                        },
                        xAxis: {
                            labels: {
                                enabled: false
                            }
                        },
                        yAxis: {
                            title: {
                                text: null
                            },
                            stackLabels: {
                                enabled: true,
                                formatter: function () {
                                    return this.total + ' days';
                                }
                            }
                        },

                        series: [

                            {
                                name: i18n.REQS_EXPECTED_TIME_TO_FILL,

                                borderColor: 'black',
                                dashStyle: 'dash',

                                data: [$scope.timeToFill],
                                color: '#79BFFC',
                                stack: 'Predict',


                                dataLabels: {
                                    enabled: true,
                                    inside: true,
                                    align: 'right',
                                    color: ($scope.timeToFill === 0) ? '#4A4A4A' : 'white'
                                }

                            },

                            {
                                name: i18n.REQS_DAYS_OPEN,
                                data: [$scope.daysOpen],
                                color: '#4A4A4A',

                                stack: 'Predict',
                                dataLabels: {
                                    enabled: true,
                                    inside: true,
                                    align: 'right',
                                    color: 'white'
                                }
                            },

                            {
                                name: i18n.REQS_COMPANY_MEDIAN,
                                data: [$scope.companyMedian],
                                stack: 'Company Median',
                                color: '#778A9A',
                                dataLabels: {
                                    inside: false
                                }
                            },

                            {
                                name: i18n.REQS_BENCHMARK_MEDIAN,
                                data: [$scope.industryMedian],
                                color: '#BABEC8',
                                stack: 'Industry Median',
                                dataLabels: {
                                    inside: false
                                }
                            }

                        ]
                    };
                    $scope.showTTFWidget = true;
                });
            }
        };

        var getApplicationBySourceData = function () {
            if ($scope.params && $scope.params.id) {
                Reqs.summary($scope.params.id, function (requisitions) {
                    angular.extend($scope.requisitions, requisitions);
                });
            }
        };

        $scope.drawChart = false;
        var options = angular.extend({
            paginated: $scope.flags.paginated
        }, $scope.params);

        /**
         * Set undefined to variables.
        */
        var setUndefined = (function () { return; }());

        $scope.$watch('requisitions.sourceType', function (newValue) {
            if (newValue && $scope.params && $scope.params.id && $scope.requisitions.views.analytics) {
                Reqs.analytics($scope.params.id, function (requisition) {
                    $scope.drawChart = true;
                    $scope.flags.loading = false;
                    if (requisition) {
                        angular.extend($scope.requisitions, requisition);
                    }
                }, (options && options.readMode) ? options.readMode : setUndefined);
            }
        }, true);

        if ($scope.requisitions) {
            $scope.requisitions.sourceType = null;
        }
        if ($scope.$parent.tabClicked === 'analytics') { // On click of tab
            getAnalyticsData();
            getApplicationBySourceData();
        } else if ($scope.activeTab('#/analytics')) { // On pagination or On Refresh
            Reqs.details(options, function (requisition) {
                angular.extend($scope.requisitions, requisition);
                if ($scope.requisitions.forumBaseUrl) {
                    $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
                }
                $scope.params.id = $scope.requisitions.jobDetails.EId;
                //Fetch the notes count only if the notes tab is visible
                if ($scope.requisitions.views.notesTab) {
                    Reqs.getNotesCount($scope.params.id, function (response) {
                        $scope.$parent.requisitions.notesCount = response.notesCount;
                    });
                }
                getAnalyticsData();
                getApplicationBySourceData();
            });
        }
    }]);